import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { agentChatSlice } from './agentChatSlice';

export const agentStore = configureStore({
  reducer: {
    agentChat: agentChatSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
});

export type RootState = ReturnType<typeof agentStore.getState>;
export type AppDispatch = typeof agentStore.dispatch;

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();

export type { AgentChatState, ChatError, Message, StreamingStatus } from './agentChatSlice';
export {
  agentChatSlice,
  approvalSent,
  chatCleared,
  errorCleared,
  errorOccurred,
  finalResponseQueued,
  messageSent,
  messagesRestored,
  progressUpdated,
  streamEnded,
  threadIdUpdated,
  tokenReceived,
  toolStarted,
  typingCompleted,
} from './agentChatSlice';
export { retryMessage, sendApproval, sendMessage } from './agentChatThunks';
export * from './selectors';
